<template>
    <div class="main-basic-info-data">
    <span class="main-basic-info-data__item" v-if="car.color">
      <span class="main-basic-info-data__text" :class="{ 'b-empty shine-short': !dataLoadedCar }">
        {{ car.color }}
      </span>
    </span>
        <span class="main-basic-info-data__item">
      <span class="main-basic-info-data__text" :class="{ 'b-empty shine-short': !dataLoadedCar }">
        <b>{{ car.drive_train }}</b>
      </span>
    </span>
        <span class="main-basic-info-data__item">
      <span class="main-basic-info-data__text" :class="{ 'b-empty shine-short': !dataLoadedCar }">
          <template v-if="flagCarInStock">
              <b>{{ car.transmision }}</b>
          </template>
          <template v-else>
              {{ car.transmision }}
          </template>
        <b>{{ car.transmision_description }}</b>
      </span>
    </span>
        <span class="main-basic-info-data__item" v-if="!car.color">
      <span class="main-basic-info-data__text" :class="{ 'b-empty shine-short': !dataLoadedCar }">
        <b>Nýtt ökutæki</b>
      </span>
    </span>
        <span class="main-basic-info-data__item">
      <span class="main-basic-info-data__text" :class="{ 'b-empty shine-short': !dataLoadedCar }">
        <b>{{getFuel}}</b>
      </span>
    </span>
    </div>
</template>

<script>
    export default {
        props: {
            car: {
                type: Object
            }
        },
        computed: {
            dataLoadedCar() {
                return this.$store.getters.carLoaded;
            },
            flagCarInStock() {
                return this.$route.name == "CarInStock"
            },
          getFuel() {
              const car = this.car;

              if(car.fuel_filter_id == 9000){
                return (car.fuel + " " + car.fuel2).replace('Rafmagn', '') + ' Hybrid';
              }

              return car.fuel + (car.fuel2 ? ", " + car.fuel2 : "")
          }
        }
    };
</script>